import { styled, Typography } from '@mui/material';

export const BodyText = styled(Typography)(({ theme }) => ({
  color: theme.palette.greyShades.grey1,
  lineHeight: '140%',
  strong: {},
  a: {
    color: theme.palette.mainColors.blue,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  table: {
    width: '100%',
    '&, & td': {
      border: '1px solid',
      borderColor: theme.palette.greyShades.grey1,
      borderCollapse: 'collapse',
      padding: '4px 8px',
    },
    td: {
      '&:nth-child(3)': {
        textAlign: 'center',
      },
    },
  },
}));
